// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oDli","textarea":"styles_textarea__3xjn4"};